export default __webpack_public_path__ + "static/typescript-1a203e65baa39b0b972d571e6257a036.png";